(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enquiry-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const nameInput = document.querySelector('[data-enquiry-name]');
    const pieceInput = document.querySelector('[data-enquiry-piece]');
    const messageTextarea = document.querySelector('[data-enquiry-message]');

    if (!nameInput || !pieceInput || !messageTextarea) return;

    const buildMessage = () => {
      const name = nameInput.value.trim();
      const piece = pieceInput.value.trim();

      let message = `Hello Juan,\n\n`;

      if (name) {
        message += `My name is ${name} and `;
      }

      if (piece) {
        message += `I'm interested in your piece "${piece}".\n\n`;
      } else {
        message += `I'm interested in one of your pieces.\n\n`;
      }

      message += `Could you please share more details about it?\n\nThank you!`;

      messageTextarea.value = message;
    };

    nameInput.addEventListener('input', buildMessage);
    pieceInput.addEventListener('input', buildMessage);

    // Inicial
    buildMessage();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
